var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_25_5804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 661",
    d: "M15.9951 9.41629V6.13211L4.75439 12.9375L15.9951 9.41629Z",
    fill: "#999999",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 660",
    d: "M12.5351 3.34375L1.33447 9.75488L4.68637 12.9375L16.4529 5.7924L12.5351 3.34375Z",
    fill: "white",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_5804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodao);
export default __webpack_public_path__ + "static/media/podao.99a936335dc1ab9076c4f5daeeef85a3.svg";
export { ForwardRef as ReactComponent };